
export default {
  owner: {
    label: 'Owner',
    defaultRoute: { name: 'account' }
  },
  admin: {
    label: 'Admin',
    defaultRoute: { name: 'customers' }
  },
  staff: {
    label: 'Staff',
    defaultRoute: { name: 'customers' }
  },
}
